import React, { useState, useEffect, useRef } from "react";
import Video from "../../assets/codevideo2.mp4";
import { FaChevronDown } from "react-icons/fa";
import "./HeroImgStyles.css";

const HeroImg = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showArrow, setShowArrow] = useState(true);
  const videoRef = useRef(null);

  const scrollToProjects = () => {
    const projectsSection = document.querySelector('#projects');
    if (projectsSection) {
      projectsSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };


  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleLoadedData = () => {
        setVideoLoaded(true);
        // Pequeño delay para asegurar que el video esté listo
        setTimeout(() => {
          setIsPlaying(true);
        }, 100);
      };

      // Detectar si es móvil
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      if (isMobile) {
        // En móviles, forzar la reproducción
        video.addEventListener('canplay', () => {
          setVideoLoaded(true);
          // Forzar reproducción en móviles
          video.play().then(() => {
            setIsPlaying(true);
          }).catch((error) => {
            console.log('Error al reproducir video en móvil:', error);
            // Si falla, intentar de nuevo después de un delay
            setTimeout(() => {
              video.play().catch(() => {
                console.log('Segundo intento fallido');
              });
            }, 1000);
          });
        });

        // Agregar evento de interacción del usuario para forzar reproducción
        const handleUserInteraction = () => {
          video.play().then(() => {
            setIsPlaying(true);
          }).catch((error) => {
            console.log('Error al reproducir video con interacción del usuario:', error);
          });
          // Remover el evento después del primer clic
          document.removeEventListener('touchstart', handleUserInteraction);
          document.removeEventListener('click', handleUserInteraction);
        };

        document.addEventListener('touchstart', handleUserInteraction);
        document.addEventListener('click', handleUserInteraction);
        
        return () => {
          document.removeEventListener('touchstart', handleUserInteraction);
          document.removeEventListener('click', handleUserInteraction);
        };
      } else {
        // En desktop, usar loadeddata
        video.addEventListener('loadeddata', handleLoadedData);
        
        return () => {
          video.removeEventListener('loadeddata', handleLoadedData);
        };
      }
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowArrow(false);
      } else {
        setShowArrow(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="hero">
      {/* Partículas Sutiles */}
      <div className="subtle-particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
      </div>

      {/* Líneas de Energía Sutiles */}
      <div className="subtle-energy-lines">
        <div className="energy-line line-1"></div>
        <div className="energy-line line-2"></div>
      </div>

      {/* Overlay Sutil */}
      <div className="subtle-overlay"></div>

      <div className="mask">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          webkit-playsinline="true"
          className={`into-img ${videoLoaded ? 'loaded' : ''} ${isPlaying ? 'playing' : ''}`}
          style={{ opacity: videoLoaded ? 1 : 0 }}
        >
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta el elemento video.
        </video>
        
        {/* Efecto de Shimmer Sutil */}
        <div className="subtle-shimmer"></div>
        
        {/* Vignette Sutil */}
        <div className="subtle-vignette"></div>
        
        <div className="content">
          <p className="greeting">HI! 👋 I AM</p>
          <h1>FullStack Developer.</h1>
          <p className="subtitle">
            Crafting exceptional digital experiences with clean code and innovative design
          </p>
          <div className="btn-container">
            <a href="#projects" className="btn btn-primary">
              View Projects
            </a>
            <a href="#contact" className="btn btn-secondary">
              Contact
            </a>
          </div>
        </div>
      </div>
      
      {/* Flecha flotante - fuera del contenido para estar en el borde del video */}
      {showArrow && (
        <div className="floating-arrow" onClick={scrollToProjects}>
          <FaChevronDown className="arrow-icon" />
        </div>
      )}
    </div>
  );
};

export default HeroImg;
